<div class="prepare-document-container">
  <div class="prepare-document-header">
    <p class="prepare-document-header-text">
      {{ 'Import PDF' | translate }}
    </p>
  </div>
  <mat-divider class="prepare-document-header-divider"></mat-divider>
  <p class="prepare-document-filename-text">{{ fileName }}</p>

  <p class="prepare-document-text">{{ statusText | translate }}</p>

  <p class="prepare-document-large-file-text" *ngIf="largeFile">
    {{ 'You are uploading a large file, this might take a while' | translate }}..
  </p>

  <div class="prepare-document-progress-bar progress">
    <div
      class="prepare-document-progress-bar-value progress-bar"
      [class.progress-bar-animated]="value !== 100"
      [class.progress-bar-striped]="value === 100"
      [style.width]="value + '%'"
    ></div>
  </div>
</div>
